module.exports = __webpack_public_path__ + "img/pdf-cover.b49ebc54.png";